/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Session')
    .factory('SessionTimeout', ['$timeout', function($timeout) {
        var
            timeoutTime,
            sessionTimeout,
            // if we need more than one callback - change to array and utilize Observer pattern
            callbackFunction = function() {};

        return {
            register: function(secondsTimeout, callback) {
                timeoutTime = secondsTimeout * 1000;
                callbackFunction = callback;
            },
            restart: function() {

                $timeout.cancel(sessionTimeout);

                if(timeoutTime) {
                    sessionTimeout = $timeout(function(){
                        callbackFunction();
                    }, timeoutTime);
                }

            }
        }
    }]);



